var siteSearch = function () {
	$(function () {

		var PAS = PAS || {};
		PAS.siteSearch = (function ($) {

		  return {
				results: null,
				init: function () {
				  this.initForm();
			},
			initForm: function () {

			  // On first load get results.
			  PAS.siteSearch.search();

			},
			search: function () {

			  // Perform and ajax search
			  $.ajax({
			      url: '/umbraco/api/sitesearch/sitesearch?keywords=' + $('#keywords').val().replace(/[^a-z0-9 ]/ig, '').trim() + '&page=' + $('#page').val(),
				type: 'GET',
				traditional: true,
				success: PAS.siteSearch.loadResults,
				error: function (result) {
				  console.log(result);
				  console.log("An error occurred when searching.");
				}
			  });
			},
			loadResults: function (jsonData) {

				$('#results').empty();
				$('#searchResultCount').empty();
				$('#pagination').empty();
				$('#pager').empty();

				$('#searchResultCount').append(jsonData.totalResultCount);

				$.each(jsonData.results, function (i, result) {
					$('#results')
					.append($('<div class="c-search-result">')
					.append($('<div class="c-search-result-path">').append($('<span>').append(result.path)))
					.append($('<div class="c-search-result-title">').append($('<a>').attr('href', result.url).append($('<span>').append(result.heading))))
					.append($('<div class="c-search-result-content">').append(result.content)));
				});

				for (var i = 1; i <= parseInt(jsonData.totalPages) ; i++) {
					if (i === parseInt($('#page').val())) {
					    $('#pagination').append($('<li class=\'active\'>').append($('<a>').attr('href', '/search?keywords=' + $('#keywords').val().replace(/[^a-z0-9 ]/ig, '').trim() + '&page=' + i).append(i)));
					} else {
					    $('#pagination').append($('<li>').append($('<a>').attr('href', '/search?keywords=' + $('#keywords').val().replace(/[^a-z0-9 ]/ig, '').trim() + '&page=' + i).append(i)));
					}
				}

				var previousDisabled = '';
				var nextDisabled = '';
				if (parseInt($('#page').val()) === 1)
					previousDisabled = 'class=\'disabled\'';

				if (parseInt(jsonData.totalPages) === 0 || parseInt($('#page').val()) === parseInt(jsonData.totalPages))
					nextDisabled = 'class=\'disabled\'';

				$('#pager').append($('<li ' + previousDisabled + '>').append($('<a>').attr('href', '/search?keywords=' + $('#keywords').val().replace(/[^a-z0-9 ]/ig, '').trim() + '&page=' + parseInt(parseInt($('#page').val()) - 1)).append($('<span class="sr-only">').append('Previous'))));
				$('#pager').append($('<li ' + nextDisabled + '>').append($('<a>').attr('href', '/search?keywords=' + $('#keywords').val().replace(/[^a-z0-9 ]/ig, '').trim() + '&page=' + parseInt(parseInt($('#page').val()) + 1)).append($('<span class="sr-only">').append('Next'))));
			}
		  };

		})(jQuery);

		$(function () {
		  PAS.siteSearch.init();
		});
	});
}

module.exports = siteSearch;
